import { render, staticRenderFns } from "./ModalVideoAgenda.vue?vue&type=template&id=5abf5f45&scoped=true"
import script from "./ModalVideoAgenda.vue?vue&type=script&lang=js"
export * from "./ModalVideoAgenda.vue?vue&type=script&lang=js"
import style0 from "./ModalVideoAgenda.vue?vue&type=style&index=0&id=5abf5f45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abf5f45",
  null
  
)

export default component.exports